import React, { createContext, useState, useContext, useEffect } from "react";
import Loading from "src/components/ui/Loading";

export const LoadingContext = createContext();

export const useLoading = () => {
  return useContext(LoadingContext);
};

const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isLoading) document.body.style.overflow = "hidden";
    else document.body.style = "none";
  }, [isLoading]);

  return (
    <LoadingContext.Provider
      value={{
        setLoading: setIsLoading,
      }}
    >
      {isLoading && <Loading />}
      {children}
    </LoadingContext.Provider>
  );
};

export default LoadingProvider;
